/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValideurDisponibleDto } from './ValideurDisponibleDto';
import {
    ValideurDisponibleDtoFromJSON,
    ValideurDisponibleDtoFromJSONTyped,
    ValideurDisponibleDtoToJSON,
    ValideurDisponibleDtoToJSONTyped,
} from './ValideurDisponibleDto';

/**
 * Valideurs disponibles d'une plateforme pour un tunnel.
 * @export
 * @interface ListValideursDisponiblesResponse
 */
export interface ListValideursDisponiblesResponse {
    /**
     * 
     * @type {Array<ValideurDisponibleDto>}
     * @memberof ListValideursDisponiblesResponse
     */
    items: Array<ValideurDisponibleDto>;
}

/**
 * Check if a given object implements the ListValideursDisponiblesResponse interface.
 */
export function instanceOfListValideursDisponiblesResponse(value: object): value is ListValideursDisponiblesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ListValideursDisponiblesResponseFromJSON(json: any): ListValideursDisponiblesResponse {
    return ListValideursDisponiblesResponseFromJSONTyped(json, false);
}

export function ListValideursDisponiblesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListValideursDisponiblesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ValideurDisponibleDtoFromJSON)),
    };
}

export function ListValideursDisponiblesResponseToJSON(json: any): ListValideursDisponiblesResponse {
    return ListValideursDisponiblesResponseToJSONTyped(json, false);
}

export function ListValideursDisponiblesResponseToJSONTyped(value?: ListValideursDisponiblesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ValideurDisponibleDtoToJSON)),
    };
}

